export function downloadFile(data, filename = 'file', mime) {
    var blob = new Blob([data], {
        type: mime || 'application/pdf'
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename)
    } else {
        const blobURL = window.URL.createObjectURL(blob)
        window.open(blobURL)
    }
}